import React from "react";
import moment from "moment";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  InputNumber,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Upload,
  Modal,
  Popover,
  Tag,
} from "antd";
import get from "lodash/get";
import map from "lodash/map";
import { connect } from "react-redux";

import { Controlled as CodeMirror } from "react-codemirror2";
import CodeEditor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";

import placeholderImage from "../../../assets/img/image_placeholder.jpg";

import {
  updateEmailTemplateRequest,
  createNewsletterRequest,
  uploadNewsletterImage,
  resetEmailTemplateRequest,
} from "../../../api/requests";
import {
  getAllowLoadingEmailTemplatesFromDB,
  getNewsletterCreatePermission,
  getNewsletterUpdatePermission,
  getUserShortTimezone,
} from "../../../reducers/user/selectors";

import classes from "./EmailTemplatesForm.css";
import { logout } from "../../../reducers/user/actions";
import TextArea from "antd/lib/input/TextArea";
import { withNamespaces } from "react-i18next";
import EmailTemplatePreview from "../EmailTemplatePreview";
import WYSIWYGEditor from "./WYSIWYGEditor";
import {getFormErrorMessage} from "../../../utils/errorHandler";

const { Option } = Select;

class EmailTemplatesForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isResetLoading: false,
      requestResult: {},
      html: get(props, "body", ""),
      htmlVisible: false,
      position: 0,
      selectedPosition:
        this.props.render_method === "html_render"
          ? "code"
          : this.props.render_method === "render_by_blocks"
          ? "body"
          : "textarea",
      headerChanged: false,
      bodyChanged: false,
      signatureChanged: false,
      isSave: false,
      btnText: "btn_text",
      btnHref: "btn_href",
      btnClass: "default",
    };

    this.quillRefHeader = React.createRef();
    this.quillRefBody = React.createRef();
    this.quillRefSignature = React.createRef();
  }

  componentDidMount() {
    this.setState({
      html: get(this.props, "body", ""),
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        await this.submit(values);
      }
    });
  };

  onReset = async () => {
    this.setState({ isResetLoading: true });
    try {
      await resetEmailTemplateRequest(this.props.id);
      this.props.onReset();
    } catch (e) {
      console.log(e);
    }
  };

  submit = async (values) => {
    try {
      const document = { ...values };

      // if (!this.state.headerChanged) {
      //   document.header = this.props.header;
      // }
      // if (!this.state.bodyChanged) {
      //   document.body = this.props.body;
      // }
      // if (!this.state.signatureChanged) {
      //   document.signature = this.props.signature;
      // }

      if (this.props.id) {
        await updateEmailTemplateRequest(this.props.id, document);
      } else {
        await createNewsletterRequest(document);
      }

      this.setState({
        isLoading: false,
        requestResult: {
          type: "success",
          message: this.props.i18n.t("Success"),
        },
      });

      setTimeout(() => {
        if (this.state.isSave) {
          this.props.onSubmit(this.props.id);
        } else {
          this.props.onReset();
        }
      }, 1000);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        isLoading: false,
        requestResult: {
          type: "error",
          message: getFormErrorMessage(e),
        },
      });

      if (get(e, "response.data.errors")) {
        const errors = {};
        Object.keys(get(e, "response.data.errors")).forEach((errorFieldKey) => {
          errors[errorFieldKey] = {
            value: values[errorFieldKey],
            errors: get(e, `response.data.errors.${errorFieldKey}`).map(
              (errorMessage) => new Error(errorMessage)
            ),
          };
        });
        this.props.form.setFields(errors);
      }
    }
  };

  onSend = () => {
    this.submit(this.props.form.getFieldsValue(), true);
  };

  onCategoryChange = () => {
    this.props.form.setFieldsValue({ type: null });
  };

  addVariable = (variable, noWrap) => {
    noWrap = noWrap || false;
    let variableContent = '';
    if (noWrap){
      variableContent = ` ${variable} `;
    }else{
      variableContent = ` {{${variable}}} `;
    }


    if (["header", "body", "signature"].includes(this.state.selectedPosition)) {
      let quillRef;

      if (this.state.selectedPosition === "header") {
        quillRef = this.quillRefHeader.current.getEditor();
        this.setState({ headerChanged: true });
      }
      if (this.state.selectedPosition === "body") {
        quillRef = this.quillRefBody.current.getEditor();
        this.setState({ bodyChanged: true });
      }
      if (this.state.selectedPosition === "signature") {
        quillRef = this.quillRefSignature.current.getEditor();
        this.setState({ signatureChanged: true });
      }
      quillRef.insertText(this.state.position, variableContent);
    } else {
      const start = this.state.html.slice(0, this.state.position);
      const end = this.state.html.slice(this.state.position);

      this.setState({
        html: start + variableContent + end,
      });
    }
  };

  render() {
    const { isLoading, isResetLoading, requestResult } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      roles,
      newsletterUpdatePermission,
      newsletterCreatePermission,
      id,
      isNew,
      available_variables,
      send_at,
      ends_date,
      sites,
    } = this.props;

    const isEditable = id
      ? newsletterUpdatePermission
      : newsletterCreatePermission;

    return (
      <div className={classes.wrapper}>
        {!this.props.getAllowLoadingEmailTemplatesFromDB && (
          <div>
            <Alert
              message={this.props.i18n.t("NamespaceEmailTemplates:WARNING! Loading email templates from the database is turned OFF in the project settings. The changes made here will have no effect.")}
              type="error"
            />
            &nbsp; &nbsp;
          </div>
        )}
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.alias}{" "}
                <Badge
                  count={this.props.i18n.t("Edit")}
                  style={{ backgroundColor: "#2968AE" }}
                />
              </span>
            ) : isNew ? (
              this.props.i18n.t(
                "NamespaceEmailTemplates:Add New Email Template"
              )
            ) : (
              ""
            )}
          </h4>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Path")}: </b>
                <i>{get(this.props, "path")}</i>


                {this.props.is_modified && (
                  <span>&nbsp;&nbsp;
                    <Badge
                      count="Modified"
                      style={{
                        backgroundColor: "#fc6262"
                      }}
                    />
                  </span>
                )}

                {this.props.state == 'active' && (
                  <span>&nbsp;&nbsp;
                    <Badge
                      count="Overridden"
                      style={{
                        backgroundColor: "#62a5fc"
                      }}
                    />
                  </span>
                )}


                <br />
                <button
                  onClick={() => {
                    this.setState({ isPreview: true });
                  }}
                  type="button"
                  className="empty-button"
                >
                  {this.props.i18n.t("Preview")}
                </button>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Alias")}</b>
                <Form.Item>
                  {getFieldDecorator("alias", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "alias"),
                  })(<Input disabled={!isEditable} type="text" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <hr />
          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Subject")}</b>
                <Form.Item>
                  {getFieldDecorator("subject_text", {
                    rules: [{ required: false, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "subject_text"),
                  })(<Input disabled={!isEditable} type="text" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <hr />
          <br/>

          {get(this.props, "render_method", "") !== "render_by_blocks" && this.props.available_variables &&
            this.props.available_variables.length > 0 && (
              <div style={{ margin: "0 0 10px" }}>
                <div>
                  <b>{this.props.i18n.t("Variables")}:</b>
                </div>
                {map(this.props.available_variables, (variable, i) => (
                  <span key={i}>
                    <Badge
                      key={variable}
                      count={variable}
                      style={{ backgroundColor: "#2968AE", cursor: "pointer" }}
                      onClick={() => {
                        this.addVariable(variable);
                      }}
                    />
                    &nbsp;
                  </span>
                ))}

                <div style={{ margin: "10px 0" }}>
                  <Popover
                    trigger={"click"}
                    placement="bottom"
                    visible={this.state.isAddButtonVisible}
                    onVisibleChange={(visible) => {
                      this.setState({ isAddButtonVisible: visible });
                    }}
                    content={
                      <div>
                        <div>
                          <div style={{marginBottom: "5px"}}>
                            <div
                              style={{
                                color: "#707070",
                                maxWidth: "767px",
                                padding: "2px 5px",
                                display: "inline-block"
                              }}
                            >
                              <i>{this.props.i18n.t("NamespaceEmailTemplates:For best results place the button on a separate line.")}</i>
                            </div>
                          </div>
                          <div style={{marginBottom: "5px"}}>
                            <Input
                              style={{width: "100%", maxWidth: '470px'}}
                              value={this.state.btnText}
                              onChange={(e) => {
                                this.setState({btnText: e.target.value});
                              }}
                            />
                          </div>
                          <div style={{marginBottom: "5px"}}>
                            <Input
                              style={{width: "100%", maxWidth: '470px'}}
                              value={this.state.btnHref}
                              onChange={(e) => {
                                this.setState({btnHref: e.target.value});
                              }}
                            />
                          </div>
                          <div style={{marginBottom: "5px"}}>
                            <Select
                              style={{width: "100%", maxWidth: '470px'}}
                              onChange={(value) => {
                                this.setState({btnClass: value});
                              }}
                              value={this.state.btnClass}
                            >
                              {[
                                "default",
                                "primary",
                                "dashed",
                                "link",
                                "warning",
                                "danger",
                              ].map((item) => (
                                <Option value={item} key={item}>
                                  {item}
                                </Option>
                              ))}
                            </Select>
                          </div>

                          <div style={{marginBottom: "5px"}}>
                            <div
                              style={{
                                color: "#707070",
                                maxWidth: "767px",
                                background: "#eee",
                                padding: "2px 5px",
                                display: "inline-block"
                              }}
                            >{`<% button text="${this.state.btnText}" href="${this.state.btnHref}" class="${this.state.btnClass}" %>`}</div>
                          </div>


                          <Badge
                            count={`Add button`}
                            style={{
                              backgroundColor: "#2968AE",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              this.addVariable(
                                `<% button text="${this.state.btnText}" href="${this.state.btnHref}" class="${this.state.btnClass}" %>`, true
                              );

                              this.setState({
                                isAddButtonVisible: false,
                              });
                            }}
                          />
                        </div>
                      </div>
                    }
                  >
                    <a
                      className="ant-dropdown-link"
                      onClick={(e) => e.preventDefault()}
                    >
                      {this.props.i18n.t("Add button shortcut")} <Icon type="down"/>
                    </a>
                  </Popover>
                </div>
              </div>
            )}

          {(get(this.props, "render_method", "") === "render_text" ||
            !get(this.props, "render_method", "")) && (
            <Row gutter={12} style={{ marginBottom: "1rem" }}>
              <Col>
                <Form.Item>
                  {getFieldDecorator("body", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "body", ""),
                  })(
                    <label>
                      <h5>{this.props.i18n.t("Text")}</h5>
                      <TextArea
                        onChange={(e) =>
                          this.setState({ html: e.target.value })
                        }
                        autoSize={{ minRows: 2, maxRows: 4 }}
                        value={get(this.state, "html", "")}
                        onKeyUp={(e) => {
                          this.setState({
                            position: e.target.selectionStart,
                            selectedPosition: "textarea",
                            bodyChanged: true,
                          });
                        }}
                        onClick={(e) => {
                          this.setState({
                            position: e.target.selectionStart,
                            selectedPosition: "code",
                          });
                        }}
                      />
                    </label>
                  )}
                </Form.Item>
              </Col>
            </Row>
          )}

          {get(this.props, "render_method", "") === "html_render" && (
            <Row gutter={12} style={{ marginBottom: "1rem" }}>
              <Col>
                <Form.Item>
                  {getFieldDecorator("body", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "body", ""),
                  })(
                    <label>
                      <h5>{this.props.i18n.t("HTML")}</h5>

                      {/*<CodeMirror
                          editorDidMount={(editor) => {
                            this.editorInstance = editor;
                          }}
                          value={get(this.state, "html", "")}
                          onBeforeChange={(editor, data, value) => {
                            this.setState({ html: value });
                          }}
                          options={{
                            mode: "html",
                            theme: "material",
                            lineNumbers: true,
                          }}
                        />*/}

                      <div className="simple-code-editor">
                        <CodeEditor
                          value={get(this.state, "html", "")}
                          language="html"
                          placeholder=""
                          // onChange={(code) => {
                          //   this.setState({ html: code.target.value });
                          // }}
                          onValueChange={(code) => {
                            this.setState({ html: code });
                          }}
                          highlight={(code) => {
                            return highlight(code, languages.js);
                          }}
                          padding={10}
                          style={{
                            fontFamily: '"Fira code", "Fira Mono", monospace',
                            fontSize: 12,
                          }}
                          onClick={(e) => {
                            this.setState({
                              position: e.target.selectionStart,
                              selectedPosition: "code",
                            });
                          }}
                          onKeyUp={(e) => {
                            this.setState({
                              position: e.target.selectionStart,
                              selectedPosition: "code",
                            });
                          }}
                        />
                      </div>

                      {/*<TextArea
                          onChange={(e) => this.setState({ html: e.target.value })}
                          value={
                            get(this.state, "html", "")
                          }
                          size="large"
                          autoSize={{ minRows: 8, maxRows: 16 }}
                        />*/}
                    </label>
                  )}
                </Form.Item>
              </Col>
            </Row>
          )}

          {get(this.props, "render_method", "") === "render_by_blocks" && (
            <div style={{ margin: "0 0 0" }}>
              <Row gutter={12}>
                <Col>
                  <div>
                    <b>{this.props.i18n.t("NamespaceEmailTemplates:Header")}</b>
                    <WYSIWYGEditor
                      {...this.props}
                      available_variables={available_variables}
                      isEditable={isEditable}
                      getFieldDecorator={getFieldDecorator}
                      fieldName="header"
                      quillRef={this.quillRefHeader}
                      setPosition={(position, selectedPosition) => {
                        this.setState({ position, selectedPosition });
                      }}
                      onChanged={() => {
                        this.setState({ headerChanged: true });
                      }}
                    />

                    {/*<Form.Item>
                      {getFieldDecorator("body", {
                        rules: [{required: true, message: "Required"}],
                        initialValue: get(this.props, "body", ""),
                      })(
                        <ReactQuill
                          ref={this.quillRef}
                          disabled={!isEditable}
                          theme="snow"
                          onBlur={(range, source, editor) => {
                            let position = range ? range.index : 0;

                            this.setState({html: editor.getHTML(), position});
                          }}
                          modules={this.quillModules}
                        />
                      )}
                    </Form.Item>*/}
                  </div>
                </Col>
              </Row>

              <Row gutter={12}>
                <Col>
                  <div>
                    <b>{this.props.i18n.t("NamespaceEmailTemplates:Body")}</b>
                    <WYSIWYGEditor
                      {...this.props}
                      available_variables={available_variables}
                      isEditable={isEditable}
                      getFieldDecorator={getFieldDecorator}
                      fieldName="body"
                      required
                      quillRef={this.quillRefBody}
                      setPosition={(position, selectedPosition) => {
                        this.setState({ position, selectedPosition });
                      }}
                      onChanged={() => {
                        this.setState({ bodyChanged: true });
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col>
                  <div>
                    <b>
                      {this.props.i18n.t("NamespaceEmailTemplates:Signature")}
                    </b>
                    <WYSIWYGEditor
                      {...this.props}
                      available_variables={available_variables}
                      isEditable={isEditable}
                      getFieldDecorator={getFieldDecorator}
                      fieldName="signature"
                      quillRef={this.quillRefSignature}
                      setPosition={(position, selectedPosition) => {
                        this.setState({ position, selectedPosition });
                      }}
                      onChanged={() => {
                        this.setState({ signatureChanged: true });
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          )}

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          {!this.props.getAllowLoadingEmailTemplatesFromDB && (
            <div>
              <Alert
                message={this.props.i18n.t("NamespaceEmailTemplates:WARNING! Loading email templates from the database is turned OFF in the project settings. The changes made here will have no effect.")}
                type="warning"
              />
              &nbsp; &nbsp;
            </div>
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className={classes.submitButton}
                  loading={isLoading}
                  onClick={() => { this.setState({ isSave: true })}}
                >
                  {this.props.i18n.t("Save")}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}
            {isEditable && (
              <Form.Item>
                <Button
                  type="default"
                  htmlType="submit"
                  className={classes.submitButton}
                  loading={isLoading}
                >
                  {this.props.i18n.t("Save and continue")}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}
            {this.props.id && (
              <Form.Item>
                <Button
                  type="default"
                  htmlType="button"
                  className={classes.submitButton}
                  onClick={() => {
                    this.onReset();
                  }}
                  loading={isResetLoading}
                >
                  {this.props.i18n.t("NamespaceEmailTemplates:Reset template body")}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Form.Item style={{ margin: "0 0 0 auto" }}>
              <Button
                type="default"
                htmlType="button"
                className={classes.submitButton}
                onClick={this.props.onCancel}
              >
                {this.props.i18n.t("Cancel")}
              </Button>
            </Form.Item>
          </div>
        </Form>

        <Modal
          visible={!!this.state.isPreview}
          onCancel={() => {
            this.setState({ isPreview: false });
          }}
          footer={null}
          wrapClassName="previewModal"
        >
          {this.state.isPreview && <EmailTemplatePreview id={this.props.id} subjectText={this.props.subject_text}/>}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  userShortTimezone: getUserShortTimezone(state),
  newsletterCreatePermission: getNewsletterCreatePermission(state),
  newsletterUpdatePermission: getNewsletterUpdatePermission(state),
  getAllowLoadingEmailTemplatesFromDB: getAllowLoadingEmailTemplatesFromDB(
    state
  ),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "EmailTemplates" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(EmailTemplatesForm))
);



// WEBPACK FOOTER //
// ./src/containers/EmailTemplates/EmailTemplatesForm/EmailTemplatesForm.js